import type { FormChallenge } from 'ProdantixSdk/core/forms';

/** How many leading bits of a digest are zero. */
export const leadingZeroBits = (digest: Uint8Array): number => {
  let bits = 0;
  for (const byte of digest) {
    if (byte !== 0) {
      return bits + Math.clz32(byte) - 24;
    }
    bits += 8;
  }
  return bits;
};

const digestOf = async (text: string): Promise<Uint8Array> => new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)));

/** Finds a solution the edge accepts: `sha256("{nonce}:{solution}")` starting
 *  with the challenge's zero bits. It runs while the visitor fills the form. */
export const solve = async (challenge: FormChallenge): Promise<string> => {
  for (let attempt = 0; ; attempt += 1) {
    const candidate = attempt.toString(36);
    if (leadingZeroBits(await digestOf(`${challenge.nonce}:${candidate}`)) >= challenge.difficulty) {
      return candidate;
    }
  }
};
